<template>
  <div class="shop">
    <div class="myShop">
      <p class="myShopTitle">{{ $t.meta.myStore }}</p>
      <div class="myShopRight">
        <button class="button-left" @click="goMyStore">
          {{ $t.meta.enterMyStore }}
        </button>
        <button class="button-right" @click="shareMyStore">
          {{ $t.meta.shareMyStore }}
        </button>
      </div>
    </div>

    <ul class="items">
      <li class="itemBox" @click="goEarning">
        <figure class="itemImg">
          <img class="itemImgIcon" src="~assets/img/store/icon_my_store_profit@2x.png" />
        </figure>
        <p class="itemTitle">{{ $t.earnings }}</p>
      </li>
      <li class="itemBox" @click="goCommodity">
        <figure class="itemImg">
          <img
            class="itemImgIcon"
            src="~assets/img/store/icon_my_store_commodity@2x.png"
          />
        </figure>
        <p class="itemTitle">{{ $t.commodity }}</p>
      </li>
      <li class="itemBox" @click="goIndent">
        <figure class="itemImg">
          <img class="itemImgIcon" src="~assets/img/store/icon_my_store_order@2x.png" />
        </figure>
        <p class="itemTitle">{{ $t.buyerOrder }}</p>
      </li>
      <li class="itemBox" @click="goAnalyze">
        <figure class="itemImg">
          <img
            class="itemImgIcon"
            src="~assets/img/store/icon_my_store_analysis@2x.png"
          />
        </figure>
        <p class="itemTitle">{{ $t.operatingData }}</p>
      </li>
      <li class="itemBox" @click="goCoupon">
        <van-badge
          color="#ff5852"
          :content="shopData.ShopCouponCount ? shopData.ShopCouponCount : null"
        >
          <figure class="itemImg">
            <img class="itemImgIcon" src="~assets/img/store/coupon_icon.png" />
          </figure>
          <p class="itemTitle">{{ $t.coupon }}</p>
        </van-badge>
      </li>
      <li class="itemBox" @click="goFans">
        <figure class="itemImg">
          <img class="itemImgIcon" src="~assets/img/store/fans_icon.png" />
        </figure>
        <p class="itemTitle">{{ $t.fans }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "myShop",
  props: {
    userData: {
      type: Object,
    },
    shopData: {
      type: Object,
    },
    shopAuth: {
      type: Object,
    },
  },
  data() {
    return {
      shareShopData: {},
    };
  },
  methods: {
    goCoupon() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "coupon",
        name: "coupon",
        query: [
          {
            name: "type",
            value: 1,
          },
        ],
      });
    },
    goFans() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "fans",
        name: "fans",
        query: [],
      });
    },
    goEarning() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "earnings",
        name: "earnings",
        query: [
          {
            name: "type",
            value: 1,
          },
        ],
      });
    },
    goCommodity() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "commodityManage",
        name: "commodityManage",
        query: [
          {
            name: "type",
            value: 1,
          },
        ],
      });
    },
    goIndent() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "indent",
        name: "indent",
        query: [
          {
            name: "type",
            value: 20,
          },
        ],
      });
    },
    goAnalyze() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "analyze",
        name: "analyze",
        query: [],
      });
    },
    goMyStore() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "mystore",
        name: "mystore",
        query: [
          {
            name: "ShopId",
            value: this.userData.ShopId,
          },
        ],
      });
    },
    goEditStore() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "editStore",
        name: "EditStore",
        query: [],
      });
    },
    shareMyStore() {
      if (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == 1) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showLoading);
        let param = {};
        this.$api.shop
          .loadShopInfo(param)
          .then((res) => {
            this.shareShopData = res.data;
            this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            if (
              !this.shareShopData.ShopHeadPhoto ||
              this.shareShopData.ShopHeadPhoto ==
                "/UploadFiles/Users/icon/icon_mine_portrait.png"
            ) {
              this.$commonMethod.customAlert(
                {
                  message: this.$t.alert.shopText,
                  cancelButtonText: this.$t.alert.cancelButtonText,
                  confirmButtonText: this.$t.alert.goUpload,
                },
                () => {
                  this.goEditStore();
                },
                () => {}
              );
            } else {
              var param = {
                name: this.shareShopData.ShopName,
                image: this.shareShopData.ShopHeadPhoto,
                linkurl: this.shareShopData.ShopUrl,
              };
              localStorage.setItem("shareShop", JSON.stringify(param));
              this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
                isParams: false,
                path: "shareShop",
                name: "ShareShop",
                query: [],
              });
            }
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
              status: error.status,
            });
          });
      } else {
        this.$commonMethod.checkAuth(this.shopAuth);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.shop {
  width: 95%;
  margin: 0 auto;
  margin-top: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  .myShop {
    @include publicFlex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    padding: 8px 10px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    .myShopTitle {
      @include divPublic;
      color: #0090e6;
      font-weight: bold;
    }
    .myShopRight {
      max-width: 75%;
      @include publicFlex;
      .button-left {
        background: transparent;
        color: #0090e6;
        border: 1px solid #0090e6;
        padding: 2px 7px 2px 7px !important;
        border-radius: 50px;
        font-size: 14px;
      }
      .button-right {
        background: #0090e6;
        color: #ffffff;
        border: 1px solid transparent;
        padding: 2px 7px 2px 7px !important;
        border-radius: 50px;
        margin-left: 5px;
        font-size: 14px;
      }
    }
  }
  .items {
    width: 100%;
    padding: 0;
    margin: 0 auto;
    justify-content: space-around;
    -webkit-justify-content: space-around;
    list-style: none;
    padding-bottom: 15px;
    .itemBox {
      padding-top: 10px;
      text-align: center;
      width: 25%;
      list-style: none;
      display: inline-block;
      .itemImg {
        width: 45px;
        height: 45px;
        display: inline-block;
        margin: 0;
        .itemImgIcon {
          width: 100%;
        }
      }
      .itemTitle {
        @include divPublic;
        color: #666;
        font-size: 14px;
      }
      ::v-deep .van-badge {
        top: 5px !important;
        right: 5px !important;
        border: none !important;
        padding: 1px 1px 1px 1px;
        font-family: initial !important;
      }
    }
  }
}
</style>
